import { Box } from "@chakra-ui/react";
import ArrowDownIcon from "@root/assets/icons/arrow-down.svg";

interface ScrollToBottomButtonProps {
  show: boolean;
  onClick: () => void;
  bottomOffset?: string;
}

export const ScrollToBottomButton = ({
  show,
  onClick,
  bottomOffset = "215px",
}: ScrollToBottomButtonProps) => {
  if (!show) return null;

  return (
    <Box
      position="absolute"
      bottom={bottomOffset}
      left="50%"
      transform="translateX(-50%)"
      zIndex={1001}
      cursor="pointer"
      onClick={onClick}
      transition="opacity 0.2s, transform 0.2s"
      _hover={{
        transform: "translateX(-50%) scale(1.05)",
      }}
      role="button"
      aria-label="Scroll to bottom"
      pointerEvents="auto"
    >
      <img
        src={ArrowDownIcon}
        alt="Scroll to bottom"
        style={{
          width: "52px",
          height: "52px",
          display: "block",
        }}
      />
    </Box>
  );
};
